/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable */
import React from 'react';
import cn from 'classnames';

import LidarIframe from 'react-scale/components/website/index/Products/examples/LidarIframe';
import Spinner from 'react-scale/components/elements/spinner';

import Annotation from '../annotation';
import styles from './Viewer.module.css';

export default class Viewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      annotationsByLabel: [],
      frame: this.props.scene.frame,
      hideAnnotationsByLabel: []
    };
  }

  updateAnnotations = annotations => {
    const annotationsByLabel = annotations.map(annotationsByFrame =>
      annotationsByFrame.cuboids.reduce((acc, cuboid) => {
        if (acc[cuboid.label]) {
          acc[cuboid.label].count += 1;
        } else {
          acc[cuboid.label] = { count: 1, color: cuboid.color };
        }
        return acc;
      }, {})
    );

    this.setState({ annotationsByLabel });
  };

  updateFrame = frame => {
    this.setState({ frame });
  };

  updateHideAnnotationsByLabel = label => {
    if (this.state.hideAnnotationsByLabel.includes(label)) {
      this.setState({
        hideAnnotationsByLabel: this.state.hideAnnotationsByLabel.filter(
          labelItem => labelItem !== label
        )
      });
    } else {
      this.setState({
        hideAnnotationsByLabel: [...this.state.hideAnnotationsByLabel, label]
      });
    }
  };

  render() {
    const { scene, isInteractive } = this.props;
    const { annotationsByLabel, frame } = this.state;
    const annotationItems = annotationsByLabel[frame] && Object.keys(annotationsByLabel[frame]);
    return (
      <div
        className={cn(styles.wrapper, 'bg-gradient-x md:p-4 relative', {
          'grid gap-4 grid-rows-1': isInteractive
        })}
      >
        {isInteractive && (
          <div className="flex-col hidden overflow-hidden bg-white rounded-lg lg:flex">
            {(!annotationItems || annotationItems.length === 0) && <Spinner />}
            {annotationItems && annotationItems.length > 0 && (
              <>
                <span className="block py-4 text-sm font-medium tracking-widest text-center text-black uppercase border-b border-solid shrink-0 border-neutral-200">
                  Objects
                </span>
                <ul className="flex-grow h-full overflow-scroll">
                  {annotationItems.map(label => (
                    <Annotation
                      key={label}
                      id={annotationsByLabel[frame][label].count}
                      name={label}
                      onClick={() => {
                        this.updateHideAnnotationsByLabel(label);
                      }}
                      disabled={this.state.hideAnnotationsByLabel.includes(label)}
                    />
                  ))}
                </ul>
              </>
            )}
          </div>
        )}
        <div className={`${styles.iframe} md:rounded-lg overflow-hidden`}>
          <LidarIframe
            zoid
            title={scene.title}
            frames={scene.frames}
            annotations={scene.annotations}
            showImages={scene.showImages}
            frame={scene.frame}
            updateAnnotations={this.updateAnnotations}
            updateFrame={this.updateFrame}
            hideAnnotationsByLabel={this.state.hideAnnotationsByLabel}
          />
        </div>
      </div>
    );
  }
}

Viewer.defaultProps = {
  overtitle: 'Data Annotation',
  title: 'Complex Label Taxonomy',
  isInteractive: false // for being able to turn on and off annotations, currently only works for cuboid examples
};
